<template>
  <v-dialog v-model="isOpen" width="700" class>
    <v-card class>
      <v-card-title>
        <span class="headline">Choose Image</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <div v-show="false" class="file-upload-form">
              <input type="file" id="preview" @change="previewImage" accept="image/*" multiple>
            </div>
            <div class="image-preview" v-if="imageData.length > 0">
              <v-layout row wrap>
                <v-flex
                  v-bind="{ [`sm${6}`]: true, [`md${4}`]: true }"
                  v-for="(image, index) in imageData"
                  :key="index"
                >
                  <img class="preview" :src="image.src" v-bind:ref="'image' +parseInt( index )">
                </v-flex>
              </v-layout>
            </div>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions class="center">
        <v-layout wrap>
          <v-btn @click="triggerPreview">Choose Images</v-btn>
          <v-btn
            v-if="$route.name!='projectsimple'&&$route.name!='home'&& $route.name!='newproject' && $route.name!='preview'"
            @click="creationProject"
          >Create/Choose project</v-btn>
          <v-btn
            v-if="$route.name=='newproject' || $route.name=='projectsimple' || $route.name=='home' || $route.name=='preview'"
            @click="preview"
          >Go Preview</v-btn>
          <v-btn color="error" @click="toggle()">{{$t('buttons.cancel')}}</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { router } from "@/_helpers";
import axios from "axios";

export default {
  name: "modal-newimage-vue",
  data() {
    return {
      imageData: [],
      image: {
        name: "",
        file: "",
        uuid: "",
        width: "",
        height: ""
      },
      project: "",
      formData: new FormData(),
      uploadPercentage: 0
    };
  },
  mounted: async function() {
    //  In mounted get information current project.
    
    this.project = await this.$store.getters["project/getProject"];
  },
  computed: {
    isOpen: {
      get() {
        if (this.$route.name == "preview") {
          this.imageData = this.getImages;
        }
        return this.$store.getters["dialogModal/isOpenModalImg"];
      },
      set() {
        this.toggle();
        // this.imageData = this.getImages;

        return this.$store.getters["dialogModal/isOpenModalImg"];
      }
    },
    getImages: function() {
      return this.$store.getters["image/getPreviews"];
    }
  },
  methods: {
    preview() {
      this.$store.dispatch("image/savePreviews", this.imageData);
      this.toggle();
      this.$router.push("/preview");
    },
    creationProject() {
      // this.$store.dispatch("image/savePreviews", this.imageData);
      this.$router.push("/newproject");
      this.toggle();
    },
    triggerPreview() {
      const inputPreview = document.getElementById("preview");
      inputPreview.click();
      this.$store.dispatch("image/savePreviews", this.imageData);
    },
    toggle() {
      this.imageData = [];
      this.$store.dispatch("dialogModal/toggleModalImg");
      let test = this.$store.getters["image/getPreviews"];
      
    },
    async nextPageProject() {
      await this.$store.dispatch("image/getImages");
      await this.$store.getters["image/getImgProject"](this.$route.params.uuid);

      
      // router.push("project");
    },
    createdProject() {
      if (this.name != "") {
        this.$store.dispatch("project/createProject", this.name);
        this.toggle();
        this.nextPageProject();
      }
    },

    previewImage: function(event) {
      // Reference to the DOM input element
      let input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        // Define a callback function to run, when FileReader finishes its job
        let files = input.files;
        
        for (let i = 0; i < files.length; i++) {
          this.imageData.push(files[i]);
        }

        this.imageData.forEach((img, index) => {
          let reader = new FileReader();
          let imageObject = new Image();
          reader.onload = e => {
            // Note: arrow function used here, so that "this.imageData" datarefers to the imageData of Vue component
            // Read image as base64 and set to imageData
            img.src = e.target.result;
            this.$refs["image" + parseInt(index)][0].src = img.src;
            imageObject.src = img.src;
            let app = this;
            imageObject.onload = function(e) {
              img.width = this.width;
              img.height = this.height;
            };
          };
          // Start the reader job - read file as a data url (base64 format)
          reader.readAsDataURL(img);
        });
      }
    },
    async onUpload() {
      this.project = await this.$store.getters["project/getProject"];
      // 
      

      this.formData.append("file_url", this.image.file);
      this.formData.append("name", this.image.name);
      this.formData.append("media_type", "IMG");
      this.formData.append("project", this.project.uuid);
      this.formData.append("width", this.image.width);
      this.formData.append("height", this.image.height);
      // send request upload image
      this.$store.dispatch("image/postImg", this.formData);
      this.toggle();
      const img = await this.$store.getters["image/getImg"];
      return img;
    },
    nextPageImg(project) {
      if (project == null || project == undefined) {
        
      }
      
      if (this.$route.name != "projectsimple") {
        this.$router.push("/medias" + "/" + project.uuid);
      } else {
        this.$router.push("/medias" + "/" + project.uuid);
      }
    },

    async saveAndGo() {
      
      const project = await this.onUpload();
      
      //   "this.$store.getters2: ",
      //   await this.$store.getters["image/getImages"]
      // );
      this.$store.dispatch("report/getReports");
      this.nextPageProject(project);
    }
  }
};
</script>

<style scoped>
img.preview {
  width: 100%;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
  max-height: 125px !important;
}
</style>
